module.exports = __webpack_public_path__ + "img/ywyy.52672db3.png";